<mat-icon
matBadge="{{upload_total}}"
matBadgeColor="warn"
matBadgeSize="small"
matBadgeOverlap="true"
style="margin-right: 20px; margin-top: 17px; color: #000;"
*ngIf="upload_total>0"
>person</mat-icon
>